<template>
  <view-container v-if="order">
    <OrderReceipt v-if="order.registrationInfo" :order="order" />
    <OrderEdit v-else :order="order" :clientId="compClientId" />
  </view-container>
</template>
<script>
import ds from "@/datastore";
import OrderEdit from "./OrderEdit";
import OrderReceipt from "./OrderReceipt";
import { auth } from "@/mixins";
export default {
  name: "OrderDetails",
  components: { OrderEdit, OrderReceipt },
  props: ["groupId", "orderId", "clientId", "cashierId", "source"],
  mixins: [auth],
  data() {
    return {
      order: {}
    };
  },
  methods: {
    async load() {
      this.order = null;
      if (this.orderId) {
        this.order = await ds.find(
          "order",
          [this.groupId, this.orderId].join("/")
        );
        const number = this.order.number || this.order.orderId;
        if (this.order.registrationInfo) {
          this.$store.commit("setTitle", "Чек по заказу #" + number);
        } else {
          this.$store.commit("setTitle", "Открытый заказ #" + number);
        }
        if (this.auth.user.isAdmin) {
          await this.order.loadRelations(["group", "group.company"]);
        }
      } else {
        if (this.source) {
          this.order = this.source.clone();
        } else {
          this.order = ds.createRecord(
            "order",
            {
              orderId: (+new Date()).toString(),
              groupId: this.groupId,
              cashierId: this.cashierId,
              receipt: { receiptType: 1 }
            },
            { noValidate: true }
          );
        }
        this.$store.commit("setTitle", "Новый заказ / чек");
      }
    }
  },
  computed: {
    compClientId() {
      if (!this.auth.user.isAdmin) {
        return;
      }
      return (
        (this.order.group && this.order.group.company.clientId) || this.clientId
      );
    }
  },
  created() {
    this.load();
  },
  deactivated() {
    this.$destroy();
  }
};
</script>
